import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';

export const StepByStep = () => {
  const navigate = useNavigate();

  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-5xl font-extrabold text-navy mb-4">
            How It Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Get your review standee in three simple steps
          </p>
        </div>

        <div className="flex justify-center mb-12">
          <img 
            src="https://customer-assets.emergentagent.com/job_e20edfe9-c71c-4e95-b173-abda837e0358/artifacts/z7qvr5iz_NFC_Horizontal_03-03-26.gif"
            alt="NFC Review Standee Demo"
            className="max-w-full h-auto rounded-2xl shadow-lg"
          />
        </div>

        <div className="text-center">
          <Button 
            onClick={() => navigate('/shop')}
            className="bg-navy text-white hover:bg-navy/90 rounded-full px-8 py-6 text-lg font-semibold"
          >
            Get My Standee
          </Button>
        </div>
      </div>
    </section>
  );
};
